import React from "react";
import "./_ButtonWithIcon.scss";
import { ReactComponent as ArrowLeft } from "../../assets/svg/arrow_left-icon.svg";
import { ReactComponent as ArrowRight } from "../../assets/svg/arrow_right-icon.svg";
import { ReactComponent as RedoIcon } from "../../assets/svg/redo-icon.svg";
import { ReactComponent as ShareIcon } from "../../assets/svg/share-icon.svg";

class ButtonWithIcon extends React.Component {
  getButtonIcon = (icon) => {
    switch (icon) {
      default:
        return <ArrowLeft />;
      case "arrow-right":
        return <ArrowRight />;
      case "redo":
        return <RedoIcon />;
      case "share":
        return <ShareIcon />;
    }
  };

  render() {
    const { buttonText, icon, onClick, leftIcon } = this.props;
    if (leftIcon) {
      return (
        <button onClick={onClick} className="button-with-icon left-icon">
          {this.getButtonIcon(icon)}
          {buttonText}
        </button>
      );
    }
    return (
      <button onClick={onClick} className="button-with-icon right-icon">
        {buttonText}
        {this.getButtonIcon(icon)}
      </button>
    );
  }
}

export default ButtonWithIcon;
